import { render, staticRenderFns } from "./NaviGation_ProductSplicing.vue?vue&type=template&id=73aaf6e8&scoped=true"
import script from "./NaviGation_ProductSplicing.vue?vue&type=script&lang=js"
export * from "./NaviGation_ProductSplicing.vue?vue&type=script&lang=js"
import style0 from "./NaviGation_ProductSplicing.vue?vue&type=style&index=0&id=73aaf6e8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73aaf6e8",
  null
  
)

export default component.exports